export const waLink = (text: string): string =>
  `https://wa.me/37498114961?text=${encodeURIComponent(text)}`;

export const telLink = "tel:+37498114961";

export const mapEmbedSrc =
  "https://www.google.com/maps?q=Rubiniants+Street+28/1+Zeytun+Yerevan+0069&output=embed";